// Displays the upcoming Spotify queue for a room — i.e., what the instructor
// has actually cued up to play next, NOT the dancer-vote request list.
// Sourced from Spotify's `/me/player/queue` endpoint via the room poller.

export default function Queue({ queue }) {
  if (!queue || queue.length === 0) {
    return (
      <p className="text-sm text-peak-muted px-1">
        Nothing queued yet.
      </p>
    )
  }
  return (
    <ol className="space-y-1.5">
      {queue.map((track, idx) => (
        <li
          key={`${track.spotify_track_id}-${idx}`}
          className="flex items-center gap-3 px-2 py-1.5 rounded-lg"
        >
          <span className="w-5 text-center text-xs text-peak-muted font-medium">
            {idx + 1}
          </span>
          {track.album_art ? (
            <img
              src={track.album_art}
              alt=""
              className="w-9 h-9 rounded object-cover flex-none"
            />
          ) : (
            <div className="w-9 h-9 rounded bg-peak-accent/15 grid place-items-center text-sm flex-none">
              ♪
            </div>
          )}
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium truncate">{track.song_title}</p>
            <p className="text-xs text-peak-muted truncate">{track.artist}</p>
          </div>
        </li>
      ))}
    </ol>
  )
}
